// extracted by mini-css-extract-plugin
export default {"title":"property_unit_title_title__uS6Mt"};